import { render, staticRenderFns } from "./EffectTypeForm.vue?vue&type=template&id=08c27b80&"
import script from "./EffectTypeForm.vue?vue&type=script&lang=js&"
export * from "./EffectTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports